var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"container text-right"},[_vm._v("\n    "+_vm._s(_vm.$t('src/views/footerbody.7691', { '1': _vm.version, '2': _vm.buildDate }))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }